/* Dimlune - single JS file. Run-once guard + idempotent per-element inits (skill traps 8d / 8f). */
(function () {
  if (window.__dlInit) return;
  window.__dlInit = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.dl-reveal:not(.dl-visible)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('dl-visible'); }); return; }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('dl-visible'); io.unobserve(e.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    }
    els.forEach(function (el) { io.observe(el); });
  }

  function initSpotlight(root) {
    (root || document).querySelectorAll('[data-dl-spotlight]').forEach(function (hero) {
      if (hero.dataset.dlInit) return; hero.dataset.dlInit = '1';
      if (reduce || window.matchMedia('(hover: none)').matches) return; /* mobile: spotlight stays fixed on product */
      var raf = null;
      hero.addEventListener('pointermove', function (ev) {
        var r = hero.getBoundingClientRect();
        var x = ((ev.clientX - r.left) / r.width) * 100, y = ((ev.clientY - r.top) / r.height) * 100;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () { hero.style.setProperty('--dl-x', x.toFixed(1) + '%'); hero.style.setProperty('--dl-y', y.toFixed(1) + '%'); });
      });
      hero.addEventListener('pointerleave', function () { hero.style.removeProperty('--dl-x'); hero.style.removeProperty('--dl-y'); });
    });
  }

  /* Words are wrapped in <span> by Liquid already (no raw syntax if JS fails); JS only lights them. */
  function initWords(root) {
    var blocks = (root || document).querySelectorAll('[data-dl-words]');
    blocks.forEach(function (b) {
      if (b.dataset.dlInit) return; b.dataset.dlInit = '1';
      var spans = b.querySelectorAll('span');
      if (reduce) { spans.forEach(function (s) { s.classList.add('is-lit'); }); return; }
      function update() {
        var r = b.getBoundingClientRect(), vh = window.innerHeight;
        var p = (vh * 0.85 - r.top) / (r.height + vh * 0.35);
        p = Math.max(0, Math.min(1, p));
        var n = Math.round(p * spans.length);
        spans.forEach(function (s, i) { s.classList.toggle('is-lit', i < n); });
      }
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  function initScenarios(root) {
    (root || document).querySelectorAll('[data-dl-scenarios]').forEach(function (w) {
      if (w.dataset.dlInit) return; w.dataset.dlInit = '1';
      var tabs = w.querySelectorAll('[role="tab"]');
      tabs.forEach(function (t) {
        t.addEventListener('click', function () {
          tabs.forEach(function (o) {
            var on = o === t; o.setAttribute('aria-selected', on ? 'true' : 'false');
            var p = w.querySelector('#' + o.getAttribute('aria-controls'));
            if (p) { p.hidden = !on; p.classList.toggle('is-in', on); }
          });
        });
      });
    });
  }

  function addBusinessDays(date, days) {
    var d = new Date(date.getTime()), added = 0;
    while (added < days) { d.setDate(d.getDate() + 1); var wd = d.getDay(); if (wd !== 0 && wd !== 6) added++; }
    return d;
  }
  function initShipping(root) {
    (root || document).querySelectorAll('[data-dl-eta]').forEach(function (el) {
      if (el.dataset.dlInit) return; el.dataset.dlInit = '1';
      var min = parseInt(el.dataset.min, 10) || 10, max = parseInt(el.dataset.max, 10) || 15, proc = parseInt(el.dataset.proc, 10) || 0;
      var now = new Date();
      var a = addBusinessDays(now, proc + min), b = addBusinessDays(now, proc + max);
      var fmt = { weekday: 'short', month: 'short', day: 'numeric' };
      try { el.textContent = a.toLocaleDateString('en-US', fmt) + ' \u2013 ' + b.toLocaleDateString('en-US', fmt); } catch (e) {}
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('[data-dl-faq]').forEach(function (f) {
      if (f.dataset.dlInit) return; f.dataset.dlInit = '1';
      f.querySelectorAll('.dl-faq__q').forEach(function (q) {
        q.addEventListener('click', function () {
          var item = q.closest('.dl-faq__item'), open = !item.classList.contains('is-open');
          item.classList.toggle('is-open', open); q.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  function money(cents, format) {
    var v = (cents / 100).toFixed(2);
    var withC = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    if (!format) return '$' + withC;
    return format.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, withC);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-dl-product]').forEach(function (w) {
      if (w.dataset.dlInit) return; w.dataset.dlInit = '1';
      var main = w.querySelector('.dl-gal__main img');
      w.querySelectorAll('.dl-gal__thumb').forEach(function (th) {
        th.addEventListener('click', function () {
          if (main) { main.src = th.dataset.full; main.srcset = ''; main.alt = th.dataset.alt || ''; }
          w.querySelectorAll('.dl-gal__thumb').forEach(function (o) { o.classList.toggle('is-active', o === th); });
        });
      });
      var json = w.querySelector('script[data-dl-variants]');
      if (!json) return;
      var variants = JSON.parse(json.textContent), fmt = w.dataset.moneyFormat;
      var idInput = w.querySelector('input[name="id"]'), btn = w.querySelector('button[name="add"]');
      var priceEl = w.querySelector('[data-dl-price]'), cmpEl = w.querySelector('[data-dl-compare]'), saveEl = w.querySelector('[data-dl-save]');
      function update() {
        var sel = [];
        w.querySelectorAll('.dl-buy__opt').forEach(function (fs) { var c = fs.querySelector('input:checked'); sel.push(c ? c.value : null); });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
        if (!v) { btn.disabled = true; btn.textContent = btn.dataset.unavailable; return; }
        idInput.value = v.id;
        if (priceEl) priceEl.textContent = money(v.price, fmt);
        var hasCmp = v.compare_at_price && v.compare_at_price > v.price;
        if (cmpEl) { cmpEl.hidden = !hasCmp; if (hasCmp) cmpEl.textContent = money(v.compare_at_price, fmt); }
        if (saveEl) { saveEl.hidden = !hasCmp; if (hasCmp) saveEl.textContent = saveEl.dataset.label.replace('[amount]', money(v.compare_at_price - v.price, fmt)); }
        btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.add : btn.dataset.soldout;
        var sec = w.closest('.shopify-section') || document;
        var sp = sec.querySelector('[data-dl-price-sticky]'); if (sp) sp.textContent = money(v.price, fmt);
        var sb = sec.querySelector('[data-dl-sticky] button'); if (sb) sb.disabled = !v.available;
        if (v.featured_image && main) { main.src = v.featured_image.src; main.srcset = ''; }
      }
      w.querySelectorAll('.dl-buy__opt input').forEach(function (i) { i.addEventListener('change', update); });
    });
  }

  function initQty(root) {
    (root || document).querySelectorAll('[data-dl-qty]').forEach(function (q) {
      if (q.dataset.dlInit) return; q.dataset.dlInit = '1';
      var input = q.querySelector('input');
      if (!input) return;
      var minus = q.querySelector('[data-dl-qty-step="-1"]'), plus = q.querySelector('[data-dl-qty-step="1"]');
      function clamp() {
        var min = parseInt(input.min, 10) || 1, max = parseInt(input.max, 10) || 99, v = parseInt(input.value, 10);
        if (isNaN(v)) v = min; v = Math.max(min, Math.min(max, v));
        input.value = v;
        if (minus) minus.disabled = v <= min; if (plus) plus.disabled = v >= max;
      }
      q.querySelectorAll('[data-dl-qty-step]').forEach(function (b) {
        b.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + parseInt(b.dataset.dlQtyStep, 10); clamp(); });
      });
      input.addEventListener('change', clamp);
      clamp();
    });
  }

  function initSticky(root) {
    (root || document).querySelectorAll('[data-dl-sticky]').forEach(function (bar) {
      if (bar.dataset.dlInit) return; bar.dataset.dlInit = '1';
      var sec = bar.closest('.shopify-section') || document;
      var target = sec.querySelector('.dl-buy__box');
      if (!target || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var below = !e.isIntersecting && e.boundingClientRect.top < 0;
          bar.hidden = !below; bar.classList.toggle('is-on', below);
        });
      }).observe(target);
    });
  }

  function initAll(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveals(root); initSpotlight(root); initWords(root); initScenarios(root); initShipping(root); initFaq(root); initProduct(root); initQty(root); initSticky(root);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
